module.exports = __webpack_public_path__ + "img/bicycles.7fd56edf.png";